/**
 * Global top-of-page progress bar (v1.1 C4).
 *
 * Tracks "operations in flight" so multiple concurrent mutations (e.g.
 * an admin clicking through several quick edits) still surface a
 * single, coherent progress affordance — the bar shows while
 * activeOps > 0 and hides once it drops to 0. Per Omar's spec the bar
 * also lingers at 100 % for 500 ms after completion to give the user
 * a "yes, that landed" confirmation before fading out; that linger is
 * managed at the `<TopProgressBar />` render layer via a small
 * post-completion state machine.
 *
 * The store is intentionally minimal — no per-operation labels or
 * cancellation. Mutations call `start()` before issuing and `end()`
 * in onSettled (success OR error).
 */

import { create } from "zustand";

interface ProgressState {
  activeOps: number;
  start: () => void;
  end: () => void;
}

export const useProgressStore = create<ProgressState>((set, get) => ({
  activeOps: 0,
  start: () => set({ activeOps: get().activeOps + 1 }),
  end: () => set({ activeOps: Math.max(0, get().activeOps - 1) }),
}));
